import { Component, ComponentFactoryResolver, ComponentRef, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { BlockerService } from '../../../core/service/blocker.service';
import { SpinnerContentDirective } from '../../directive/spinner.directive';
import { SpinnerComponent } from '../spinner/spinner.component';

@Component({
    selector: 'app-spinner-host',
    templateUrl: './spinner-host.component.html'
})
export class SpinnerHostComponent implements OnInit, OnDestroy {

    subscriptions: Subscription[] = [];

    spinnerRef: ComponentRef<SpinnerComponent>;
    @ViewChild(SpinnerContentDirective, {static: true}) spinnerHost: SpinnerContentDirective;

    constructor(private componentFactoryResolver: ComponentFactoryResolver,
                private blockerService: BlockerService,
                private ngZone: NgZone,
    ) {
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.blockerService.showBlocker.subscribe(show => this.toggleBlocker(show))
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    private toggleBlocker(show: boolean) {
        this.ngZone.run(() => {
            if (!show && this.spinnerRef) {
                this.spinnerRef.destroy();
                this.spinnerRef = null;
            } else if (show && !this.spinnerRef) {
                const componentFactory = this.componentFactoryResolver.resolveComponentFactory(SpinnerComponent);
                this.spinnerRef = this.spinnerHost.viewContainerRef.createComponent(componentFactory);
            }
        });
    }
}
